import type { VoidFunctionComponent } from 'react';

type Props = {
  isSmallIcon?: boolean;
};

/* eslint-disable react/no-unknown-property */
const RubygemsIcon: VoidFunctionComponent<Props> = ({ isSmallIcon }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={isSmallIcon ? 12 : 16} height={isSmallIcon ? 12 : 16} fill="none" viewBox="0 0 80 80"><path fill="#EF3F2D" fill-rule="evenodd" d="M5 20 40 0l35 20v40L40 80 5 60V20Zm35 52.444 28.312-16.266V23.733L40 7.467 11.688 23.733v32.445L40 72.444ZM25.955 26.311l.045.045-.045-.09 15.494.045h12.774l9.898 9.867-14.134 14.089-9.898 9.822-24.032-23.911 9.898-9.867Z" clip-rule="evenodd" /></svg>
  );
};

export default RubygemsIcon;
